import { ExitIntentAreas, TriggerType } from 'sections/onsite-campaigns/types';
import { TriggerAction, TriggerState } from './TriggerState';

export const TriggerReducer = (state: TriggerState, action: TriggerAction) => {
  switch (action.type) {
    case 'SET_SELECTED_TRIGGER_TYPE': {
      const { type } = action.payload;

      const hasTrigger = state.selectedTriggers.find(s => s === type);

      if (hasTrigger) {
        return state;
      }
      switch (type) {
        case TriggerType.PageLoad: {
          return {
            ...state,
            onPageLoad: true,
            selectedTriggers: [...state.selectedTriggers, type],
          };
        }
        case TriggerType.OnClick: {
          return {
            ...state,
            onClick: { selector: '', overrideFreqCaps: true },
            selectedTriggers: [...state.selectedTriggers, type],
          };
        }
        default: {
          return {
            ...state,
            selectedTriggers: [...state.selectedTriggers, type],
          };
        }
      }
    }
    case 'REMOVE_SELECTED_TRIGGER_TYPE': {
      const { type } = action.payload;

      const selectedTriggers = state.selectedTriggers.filter(s => s !== type);

      let triggerState = state;
      switch (type) {
        case TriggerType.Inactivity: {
          triggerState = {
            ...state,
            inactivity: null,
          };
          break;
        }
        case TriggerType.ExitIntent: {
          triggerState = {
            ...state,
            exitIntentAreas: [],
          };
          break;
        }
        case TriggerType.PageLoad: {
          triggerState = {
            ...state,
            onPageLoad: null,
          };
          break;
        }
        case TriggerType.OnClick: {
          triggerState = {
            ...state,
            onClick: null,
          };
          break;
        }
      }

      return {
        ...state,
        ...triggerState,
        selectedTriggers,
      };
    }
    case 'SET_INACTIVITY_DURATION_TIMER': {
      const { duration } = action.payload;

      return {
        ...state,
        inactivity: duration,
      };
    }
    case 'SET_CAMPAIGN_ALL_EXIT_INTENTS': {
      return {
        ...state,
        exitIntentAreas: Object.values(ExitIntentAreas),
      };
    }
    case 'SET_CAMPAIGN_EXIT_INTENT': {
      const { exitIntentAreas } = action.payload;
      return {
        ...state,
        exitIntentAreas: exitIntentAreas || [],
      };
    }
    case 'CLEAR_CAMPAIGN_EXIT_INTENT': {
      return {
        ...state,
        exitIntentAreas: [],
      };
    }
    case 'SEGMENTATION_CHOSEN': {
      return {
        ...state,
        segmentation: [[]],
      };
    }
    case 'CLEAR_TRIGGER_SEGMENTATION': {
      return {
        ...state,
        segmentation: undefined,
      };
    }
    case 'SAVE_TRIGGER_SEGMENTATION': {
      const { segmentation } = action.payload;
      return {
        ...state,
        segmentation,
      };
    }
    case 'SET_ON_CLICK_CONFIG': {
      const { onClick } = action.payload;

      return {
        ...state,
        onClick,
      };
    }
    case 'SET_FREQUENCY': {
      const { frequency } = action.payload;

      return {
        ...state,
        frequency: frequency,
      };
    }
    default:
      return state;
  }
};
